<template>
 <GalleryController></GalleryController>
</template>
<script>

import GalleryController from './components/gallery-controller'

export default {
	name: 'Galleries',
	data() {
		return {

		}
	},
  components : {
    GalleryController,

  },
  computed : {

  },
  methods : {

  }
}
</script>
<style lang="scss" scoped>

</style>
